import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import * as ROUTE from "./routesConstant";
import Loading2 from "../components/helpers/Loading2";
import Withdrawals from "../pages/affiliate/withdrawals";
import Subscription from "../pages/subscriptions/email/list";
import EmailFooter from "../pages/settings/email-footer";
import BankDetails from "../pages/affiliate/bank-details";
import CommiossionDetails from "../pages/affiliate/commiossion-details";
import MyLink from "../pages/affiliate/my-link";
import ReviewsList from "../pages/reviews/list";
import DetailsReview from "../pages/reviews/details";
import ReviewUpdate from "../pages/reviews/update";
import SMSManagement from "../pages/settings/sms";
import SMSSubscription from "../pages/subscriptions/sms/list";
import CartFunnels from "../pages/cart_funnel/list";
import CartFunnelDetails from "../pages/cart_funnel/details";
import CartFunnelSms from "../pages/campaign/cart-funnel/sms";
import CartFunnelEmail from "../pages/campaign/cart-funnel/email";
import GeneralEmail from "../pages/campaign/general/email";
import GeneralSms from "../pages/campaign/general/sms";
import UpdateEmailCampaign from "../pages/campaign/update/update-email-campaign";
import UpdateSMSCampaign from "../pages/campaign/update/update-sms-campaign";
import CampaignDetails from "../pages/campaign/details/details";
import PendingEmailCampaign from "../pages/campaign/pending-orders/email";
import PendingSMSCampaign from "../pages/campaign/pending-orders/sms";
import OutReachAdd from "../pages/outreach/add";
import Outreaches from "../pages/outreach/list";
import DetailOutreach from "../pages/outreach/details";
import UpdateOutreach from "../pages/outreach/update";
import AnalyticsSMS from "../pages/campaign/analytics/analytics";
import EmailsAnalytics from "../pages/campaign/analytics/email-analytics";
import Quotes from "../pages/quotes/list";
import QuoteDetails from "../pages/quotes/details";
import RefundRequests from "../pages/refund_requests/list";
import TrackingEvents from "../pages/tracking/events";
import TrackingStatsPage from "../pages/tracking/stats";
import TrackingLeads from "../pages/tracking/leads";
import TrackingJourney from "../pages/tracking/journey";
const NotificationsPage = lazy(() => import("../pages/notifications"));

const PublicLayout = lazy(() => import("../components/Layout/PublicLayout"));
const PrivateLayout = lazy(() => import("../components/Layout/PrivateLayout"));
const PageNotFound = lazy(() => import("../components/Pages/NotFound"));

// Auth & Public pages
const Login = lazy(() => import("../pages/login/login"));
const ForgotPassword = lazy(() =>
  import("../pages/forgot_password/forgot_password")
);
const ResetPassword = lazy(() =>
  import("../pages/reset_password/reset_password")
);
const SignUp = lazy(() => import("../pages/signup/signup"));
const EmailVerify = lazy(() => import("../pages/email_verify/email_verify"));

// Dashboard & Profile
const HomePage = lazy(() => import("../pages/homePage"));
const Profile = lazy(() => import("../pages/profile/profile"));
const Settings = lazy(() => import("../pages/settings/settings"));
const CartFunnel = lazy(() => import("../pages/settings/cart-funnel"));
const AbandonedCartSms = lazy(() => import("../pages/settings/abandoned-cart-sms"));
const PendingOrder = lazy(() => import("../pages/settings/pending-order"));
const AffiliateSetting = lazy(() => import("../pages/settings/affiliate"));
const EmailTemplates = lazy(() => import("../pages/settings/email-templates"));
const CreateEmailTemplates = lazy(() =>
  import("../pages/settings/create-email-templates")
);
const UpdateEmailTemplate = lazy(() =>
  import("../pages/settings/update-email-template")
);
const EmailBuilderNew = lazy(() =>
  import("../pages/settings/email-builder-new")
);
const EmailBuilderEdit = lazy(() =>
  import("../pages/settings/email-builder-edit")
);
const EmailTemplateDetails = lazy(() =>
  import("../pages/settings/email-template-details")
);
const EmailSettings = lazy(() => import("../pages/settings/email-settings"));
const AffiliateSettings = lazy(() => import("../pages/affiliate/settings"));

// Products
const ProductsList = lazy(() => import("../pages/products/list"));
const AddProduct = lazy(() => import("../pages/products/add"));
const ProductDetails = lazy(() => import("../pages/products/details"));
const ProductUpdate = lazy(() => import("../pages/products/update"));

// Users
const UserList = lazy(() => import("../pages/users/list"));
const UserAdd = lazy(() => import("../pages/users/add"));
const UserDetails = lazy(() => import("../pages/users/details"));
const UserUpdate = lazy(() => import("../pages/users/update"));

// Roles
const RoleList = lazy(() => import("../pages/roles/list"));
const RoleAdd = lazy(() => import("../pages/roles/add"));
const RoleDetail = lazy(() => import("../pages/roles/details"));
const RoleUpdate = lazy(() => import("../pages/roles/update"));

// Affiliates
const Affiliates = lazy(() => import("../pages/affiliate/list"));
const AffiliateDetails = lazy(() => import("../pages/affiliate/detail"));
const AffiliatesDetails = lazy(() => import("../pages/affiliate/details"));
const AffiliateRequest = lazy(() => import("../pages/affiliate/request"));
const AffiliateCommission = lazy(() =>
  import("../pages/affiliate/commissions")
);
const AffiliatedProducts = lazy(() =>
  import("../pages/affiliate/affiliated-products")
);
const AffiliateBankAccount = lazy(() =>
  import("../pages/affiliate/bank-account")
);
const AddBank = lazy(() => import("../pages/affiliate/add-bank"));
const UpdateBank = lazy(() => import("../pages/affiliate/update-bank"));
const WithdrawList = lazy(() => import("../pages/affiliate/withdraw-list"));
const AddWithdraw = lazy(() => import("../pages/affiliate/add-withdraw"));
const WithdrawDetails = lazy(() =>
  import("../pages/affiliate/withdraw-details")
);

// Orders
const OrderList = lazy(() => import("../pages/orders/list"));
const OrdersDetails = lazy(() => import("../pages/orders/details"));
const OrderEmail = lazy(() => import("../pages/orders/order-email"));

// Shipping
const Shipping = lazy(() => import("../pages/shipping/list"));
const AddShipping = lazy(() => import("../pages/shipping/add"));
const ShippingUpdate = lazy(() => import("../pages/shipping/update"));

// Coupons
const Coupons = lazy(() => import("../pages/coupons/list"));
const AddCoupon = lazy(() => import("../pages/coupons/add"));
const CouponDetails = lazy(() => import("../pages/coupons/details"));
const CouponUpdate = lazy(() => import("../pages/coupons/update"));

// Posts
const Posts = lazy(() => import("../pages/posts/list"));
const AddPost = lazy(() => import("../pages/posts/add"));
const PostDetail = lazy(() => import("../pages/posts/details"));
const PostUpdate = lazy(() => import("../pages/posts/update"));

// Payments
const PaymentList = lazy(() => import("../pages/payment/list"));
const PaymentDetails = lazy(() => import("../pages/payment/details"));

// Gallery & Images
const GalleryList = lazy(() => import("../pages/gallery/list"));
const GalleryDetails = lazy(() => import("../pages/gallery/details"));
const RenderedImagesList = lazy(() => import("../pages/rendered_images/list"));
const RenderedImageDetails = lazy(() =>
  import("../pages/rendered_images/details")
);

// Logs
const Logs = lazy(() => import("../pages/logs/logs"));
const LogsDetail = lazy(() => import("../pages/logs/details"));

// Contacts
const ContactsList = lazy(() => import("../pages/contacts/list"));
const ContactDetail = lazy(() => import("../pages/contacts/detail"));

// API Keys
const ApiKeysList = lazy(() => import("../pages/api_keys/list"));
const ApiKeyAdd = lazy(() => import("../pages/api_keys/add"));

// Dealers
const DealerList = lazy(() => import("../pages/dealer/list"));

// FAQ
const FaqList = lazy(() => import("../pages/faq/list"));
const AddFaq = lazy(() => import("../pages/faq/add"));
const FaqDetail = lazy(() => import("../pages/faq/details"));
const FaqUpdate = lazy(() => import("../pages/faq/update"));

// Router Component
const Router = () => {
  return (
    <Suspense fallback={<Loading2 />}>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path={ROUTE.LOGIN} element={<Login />} />
          <Route path={ROUTE.FORGETPASS} element={<ForgotPassword />} />
          <Route path={ROUTE.RESETPASS} element={<ResetPassword />} />
          <Route path={ROUTE.SIGN_UP} element={<SignUp />} />
          <Route path={ROUTE.VERIFY} element={<EmailVerify />} />
          <Route path='*' element={<PageNotFound />} />
        </Route>

        {/* Private Routes */}
        <Route element={<PrivateLayout />}>
          {/* Dashboard & Profile */}
          <Route path={ROUTE.DASHBOARD} element={<HomePage />} />
          <Route path={ROUTE.PROFILE} element={<Profile />} />
          <Route path={ROUTE.SETTINGS} element={<Settings />} />
          <Route path={ROUTE.SETTINGSCARTFUNNEL} element={<CartFunnel />} />
          <Route path={ROUTE.SETTINGS_ABANDONED_CART_SMS} element={<AbandonedCartSms />} />
          <Route
            path={ROUTE.SETTINGS_PENDINGORDER}
            element={<PendingOrder />}
          />
          <Route
            path={ROUTE.SETTINGS_AFFILIATE}
            element={<AffiliateSetting />}
          />
          <Route path={ROUTE.SMS_SETTING} element={<SMSManagement />} />
          <Route
            path={ROUTE.SETTINGSEMAILTEMPLATES}
            element={<EmailTemplates />}
          />
          <Route
            path={ROUTE.SETTINGSCREATEEMAILTEMPLATES}
            element={<CreateEmailTemplates />}
          />
          <Route
            path={ROUTE.SETTINGSUPDATEMAILTEMPLATES}
            element={<UpdateEmailTemplate />}
          />
          <Route
            path={ROUTE.EMAIL_BUILDER_NEW}
            element={<EmailBuilderNew />}
          />
          <Route
            path={ROUTE.EMAIL_BUILDER_EDIT}
            element={<EmailBuilderEdit />}
          />
          <Route
            path={ROUTE.EMAIL_TEMPLATE_DETAIL}
            element={<EmailTemplateDetails />}
          />
          <Route
            path={ROUTE.EMAILTEMPLATE_SETTING}
            element={<EmailSettings />}
          />
          <Route
            path={ROUTE.EMAILTEMPLATE_FOOTER_SETTING}
            element={<EmailFooter />}
          />
          <Route
            path={ROUTE.AFFILIATE_SETTINGS}
            element={<AffiliateSettings />}
          />

          {/* Products */}
          <Route path={ROUTE.PRODUCTS_LIST} element={<ProductsList />} />
          <Route path={ROUTE.PRODUCT_ADD} element={<AddProduct />} />
          <Route path={ROUTE.PRODUCTDETAIL} element={<ProductDetails />} />
          <Route path={ROUTE.UPDATEPRODUCT} element={<ProductUpdate />} />
          <Route path={ROUTE.REVIEWS_LIST} element={<ReviewsList />} />
          <Route path={ROUTE.REVIEWDETAIL} element={<DetailsReview />} />
          <Route path={ROUTE.UPDATEREVIEW} element={<ReviewUpdate />} />

          {/* Users */}
          <Route path={ROUTE.USER_LIST} element={<UserList />} />
          <Route path={ROUTE.USER_ADD} element={<UserAdd />} />
          <Route path={ROUTE.USERDETAIL} element={<UserDetails />} />
          <Route path={ROUTE.UPDATEUSER} element={<UserUpdate />} />

          {/* Roles */}
          <Route path={ROUTE.ROLE_LIST} element={<RoleList />} />
          <Route path={ROUTE.ROLE_ADD} element={<RoleAdd />} />
          <Route path={ROUTE.ROLEDETAIL} element={<RoleDetail />} />
          <Route path={ROUTE.UPDATE_ROLE} element={<RoleUpdate />} />

          {/* Affiliates */}
          <Route path={ROUTE.AFFILIATE_LIST} element={<Affiliates />} />
          <Route path={ROUTE.AFFILIATEDETAIL} element={<AffiliateDetails />} />
          <Route
            path={ROUTE.AFFILIATEDETAILS}
            element={<AffiliatesDetails />}
          />
          <Route
            path={ROUTE.AFFILIATE_REQUEST}
            element={<AffiliateRequest />}
          />
          <Route
            path={ROUTE.AFFILIATE_COMMISSION}
            element={<AffiliateCommission />}
          />
          <Route path={ROUTE.AFFILIATE_LINK} element={<MyLink />} />
          <Route
            path={ROUTE.COMMISSIONDETAIL}
            element={<CommiossionDetails />}
          />
          <Route
            path={ROUTE.AFFILIATE_PRODUCTS}
            element={<AffiliatedProducts />}
          />
          <Route
            path={ROUTE.AFFILIATE_BANKS_LIST}
            element={<AffiliateBankAccount />}
          />
          <Route path={ROUTE.AFFILIATE_BANK_ADD} element={<AddBank />} />
          <Route path={ROUTE.UPDATE_BANK} element={<UpdateBank />} />
          <Route path={ROUTE.BANKDETAIL} element={<BankDetails />} />
          <Route path={ROUTE.WITHDRAWALS_LIST} element={<WithdrawList />} />
          <Route path={ROUTE.AFFILIATE_WITHDRAWALS} element={<Withdrawals />} />
          <Route path={ROUTE.WITHDRAW_ADD} element={<AddWithdraw />} />
          <Route path={ROUTE.WITHDRAWDETAIL} element={<WithdrawDetails />} />

          {/* Orders */}
          <Route path={ROUTE.ORDER_LIST} element={<OrderList />} />
          <Route path={ROUTE.ORDERDETAIL} element={<OrdersDetails />} />
          <Route path={ROUTE.ORDEREMAILDETIAL} element={<OrderEmail />} />

          {/* Shipping */}
          <Route path={ROUTE.SHIPPING_LIST} element={<Shipping />} />
          <Route path={ROUTE.SHIPPING_ADD} element={<AddShipping />} />
          <Route path={ROUTE.UPDATE_SHIPPING} element={<ShippingUpdate />} />

          {/* Coupons */}
          <Route path={ROUTE.COUPON_LIST} element={<Coupons />} />
          <Route path={ROUTE.COUPON_ADD} element={<AddCoupon />} />
          <Route path={ROUTE.COUPONDETAIL} element={<CouponDetails />} />
          <Route path={ROUTE.UPDATECOUPON} element={<CouponUpdate />} />

          {/* Posts */}
          <Route path={ROUTE.POST_LIST} element={<Posts />} />
          <Route path={ROUTE.POST_ADD} element={<AddPost />} />
          <Route path={ROUTE.POSTSDETAIL} element={<PostDetail />} />
          <Route path={ROUTE.UPDATEPOSTS} element={<PostUpdate />} />

          {/* FAQ */}
          <Route path={ROUTE.FAQ_LIST} element={<FaqList />} />
          <Route path={ROUTE.FAQ_ADD} element={<AddFaq />} />
          <Route path={ROUTE.FAQ_DETAIL} element={<FaqDetail />} />
          <Route path={ROUTE.FAQ_UPDATE} element={<FaqUpdate />} />

          {/* Payments */}
          <Route path={ROUTE.PAYMENT_LIST} element={<PaymentList />} />
          <Route path={ROUTE.PAYMENTDETAIL} element={<PaymentDetails />} />

          {/* Gallery & Images */}
          <Route path={ROUTE.GALLERY_LIST} element={<GalleryList />} />
          <Route path={ROUTE.GALLERYDETAIL} element={<GalleryDetails />} />
          <Route
            path={ROUTE.RENDERED_IMAGES_LIST}
            element={<RenderedImagesList />}
          />
          <Route
            path={ROUTE.RENDEREDIMAGESDETAIL}
            element={<RenderedImageDetails />}
          />

          {/* Logs */}
          <Route path={ROUTE.LOGS_LIST} element={<Logs />} />
          <Route path={ROUTE.LOGSDETAIL} element={<LogsDetail />} />

          {/* Contacts */}
          <Route path={ROUTE.CONTACT_LIST} element={<ContactsList />} />
          <Route path={ROUTE.CONTACTDETAIL} element={<ContactDetail />} />

          {/* API Keys */}
          <Route path={ROUTE.API_KEYS_LIST} element={<ApiKeysList />} />
          <Route path={ROUTE.API_KEYS_ADD} element={<ApiKeyAdd />} />

          {/* Dealers */}
          <Route path={ROUTE.DEALER_LIST} element={<DealerList />} />

          {/* Subscription */}
          <Route path={ROUTE.SUBSCRIPTIONS} element={<Subscription />} />
          <Route path={ROUTE.SMS_SUBSCRIPTIONS} element={<SMSSubscription />} />

          {/* cart-funnels */}
          <Route path={ROUTE.CART_FUNNEL_LIST} element={<CartFunnels />} />
          <Route
            path={ROUTE.CART_FUNNEL_DETAIL}
            element={<CartFunnelDetails />}
          />

          {/* campaign  */}
          <Route
            path={ROUTE.PENDING_ORDER_EMAIL_CAMPAIGN}
            element={<PendingEmailCampaign />}
          />
          <Route
            path={ROUTE.PENDING_ORDER_SMS_CAMPAIGN}
            element={<PendingSMSCampaign />}
          />
          <Route
            path={ROUTE.CART_FUNNEL_SMS_CAMPAIGN}
            element={<CartFunnelSms />}
          />
          <Route
            path={ROUTE.CART_FUNNEL_EMAIL_CAMPAIGN}
            element={<CartFunnelEmail />}
          />
          <Route path={ROUTE.GENERAL_SMS_CAMPAIGN} element={<GeneralSms />} />
          <Route
            path={ROUTE.GENERAL_EMAIL_CAMPAIGN}
            element={<GeneralEmail />}
          />
          <Route
            path={ROUTE.UPDATE_EMAIL_CAMPAIGN}
            element={<UpdateEmailCampaign />}
          />
          <Route
            path={ROUTE.UPDATE_SMS_CAMPAIGN}
            element={<UpdateSMSCampaign />}
          />

          <Route path={ROUTE.DETAILS_CAMPAIGN} element={<CampaignDetails />} />
          <Route
            path={ROUTE.SMS_ANALYTICS_CAMPAIGN}
            element={<AnalyticsSMS />}
          />
          <Route
            path={ROUTE.EMAIL_ANALYTICS_CAMPAIGN}
            element={<EmailsAnalytics />}
          />

          {/* outreach  */}
          <Route path={ROUTE.OUTREACH_ADD} element={<OutReachAdd />} />
          <Route path={ROUTE.OUTREACH_LIST} element={<Outreaches />} />
          <Route path={ROUTE.OUTREACH_DETAIL} element={<DetailOutreach />} />
          <Route path={ROUTE.OUTREACH_UPDATE} element={<UpdateOutreach />} />

          {/* Quotes */}
          <Route path={ROUTE.QUOTE_LIST} element={<Quotes />} />
          <Route path={ROUTE.QUOTE_DETAIL} element={<QuoteDetails />} />

          {/* Refund Requests */}
          <Route path={ROUTE.REFUND_REQUEST_LIST} element={<RefundRequests />} />

          {/* Tracking */}
          <Route path={ROUTE.TRACKING_EVENTS} element={<TrackingEvents />} />
          <Route path={ROUTE.TRACKING_STATS} element={<TrackingStatsPage />} />
          <Route path={ROUTE.TRACKING_LEADS} element={<TrackingLeads />} />
          <Route path={ROUTE.TRACKING_JOURNEY} element={<TrackingJourney />} />

          {/* Notifications */}
          <Route path={ROUTE.NOTIFICATIONS} element={<NotificationsPage />} />

          {/* Catch-all */}
          <Route path='*' element={<PageNotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Router;
